export class ChatMessageContentUpdateRepresentation {

  public readonly newContent: string;

  constructor(newContent: string) {
    this.newContent = newContent;
  }

}
